import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const tagsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "适用对象",
            prop: "clientType",
            type: 'select',
            span: 13,
            search: true,
            editVisdiplay: false,
            placeholder: '请选择客户端类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData: DIC.TAGS_CLIENT_TYPE,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择客户端类型"
            }],
        },
        {
            label: "标签名称",
            prop: "name",
            type: 'input',
            span: 13,
            search: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入标签名称"
            }],
        },
        {
            label: "关联人数",
            prop: "count",
            type: 'input',
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "工程师",
        //     prop: "name",
        //     type: 'select',
        //     formsolt:true,
        //     hide:true,
        // },
        {
            label: "绑定时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "createBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};